// cy is user ID 1
// the user is user id 0
// questions are often asked by cy
// responses are options chosen by user
// the frontend filters the next responses through the prevResponse value, where prevResponse ===  current messageId
//
import * as React from "react";
import Link from "react-router-dom/es/Link";

export const QuestionTree = {
  defaultOptions: {
    name: "default options",
    steps: {
      0: {
        name: "help options",
        questions: [
          {
            userId: 1,
            messageId: 0,
            message: "Please choose a help topic.",
            senderName: "CY",
            questionPath: null,
            selected: false,
            treeStep: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            message: "Operations Requests",
            questionPath: "defaultOptions",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          // {
          //   messageId: 3,
          //   message: "Inquiries/special instructions/etc",
          //   questionPath: "defaultOptions",
          //   selected: false,
          //   userId: 0,
          //   treeStep: 0,
          // },
          {
            messageId: 2,
            message: "Cy Settings",
            questionPath: "defaultOptions",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          // phase 2
          // {
          //   messageId: 3,
          //   message: "Cy Tools",
          //   questionPath: "defaultOptions",
          //   selected: false,
          //   userId: 0,
          //   treeStep: 0,
          // },
        ],
      },
      1: {
        name: "path selection",
        questions: [
          {
            userId: 1,
            messageId: 0,
            message: "Is this related to....",
            senderName: "CY",
            questionPath: null,
            selected: false,
            treeStep: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            message: "Distribution requests",
            questionPath: 1,
            prevResponse: 0,
            selected: false,
            userId: 0,
            treeStep: 1,
          },

          {
            messageId: 1,
            message: "Standing instructions",
            questionPath: 2,
            selected: false,
            userId: 0,
            prevResponse: 0,
            treeStep: 1,
          },
          {
            messageId: 2,
            message: "Additions to account",
            questionPath: 3,
            selected: false,
            prevResponse: 0,
            userId: 0,
            treeStep: 1,
          },
          {
            messageId: 3,
            message: "Trading requests",
            questionPath: 4,
            selected: false,
            prevResponse: 0,
            userId: 0,
            treeStep: 1,
          },
          {
            messageId: 4,
            message: "Advisor setting changes",
            questionPath: 5,
            selected: false,
            userId: 0,
            prevResponse: 2,
            treeStep: 1,
          },
          {
            messageId: 5,
            message: "Account Changes",
            questionPath: 6,
            selected: false,
            userId: 0,
            prevResponse: 0,
            treeStep: 1,
          },
        ],
      },
    },
  },
  // generic responses
  0: {
    name: "general response",
    steps: {
      //submit for help
      0: {
        name: "help confirm",
        questions: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Did you find what you were looking for?",
            selected: false,
            userId: 1,
            treeStep: 0,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 1,
            questionPath: 0,
            message: "Yes",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 0,
            questionPath: 0,
            message: "No",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        name: "secondary help options",
        questions: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Sorry about that. Would you like to...",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: 0,
          },
        ],
        responses: [
          {
            messageId: 1,
            questionPath: 0,
            message: "Submit a help request",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 0,
          },
          {
            messageId: 0,
            questionPath: 0,
            message: "Start over",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 0,
          },
        ],
      },

      //submit for help
      2: {
        name: "submit ticket",
        questions: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Sure. Please describe the issue you'd like help with.",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Topic",
            topic: "Topic",
            description: undefined,
            selected: false,
            prevResponse: 1,
            userId: 1,
            treeStep: 2,
            componentType: "select",
            options: ["option1", "option2", "option3"],
          },
        ],
      },
      3: {
        name: "ticket submitted",
        questions: [
          {
            messageId: 0,
            questionPath: 0,
            message:
              "Thank you. We will reply by email, usually within one business day.",
            selected: false,
            userId: 1,
            treeStep: 3,
            prevResponse: 1,
          },
          {
            messageId: 0,
            questionPath: 0,
            message: "Is there anything else we can help with?",
            selected: false,
            userId: 1,
            treeStep: 3,
            prevResponse: 1,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Start again",
            selected: false,
            userId: 0,
            treeStep: 3,
            urlPath: null,
            prevResponse: 0,
          },
          {
            messageId: 1,
            questionPath: 0,
            message: "No, that's all thanks.",
            selected: false,
            userId: 0,
            treeStep: 3,
            urlPath: null,
            prevResponse: 0,
          },
        ],
      },
      end: {
        name: "end",
        questions: [],
        responses: [
          {
            messageId: 0,
            questionPath: 0,
            message: "Ok, we're always here to help!",
            selected: false,
            userId: 1,
            treeStep: 4,
            urlPath: null,
            prevResponse: 1,
          },
        ],
      },
    },
  },
  // Distribution requests
  1: {
    name: "Distribution requests",
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "Is this for...",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "Non-retirement accounts",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 1,
            urlPath: null,
            message: "Retirement accounts",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "For what frequency?",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
          },
        ],
        responses: [
          {
            prevResponse: 1,
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "One Time",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 1,
            messageId: 1,
            questionPath: 1,
            urlPath: null,
            message: "Recurring",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 2,
            questionPath: 1,
            urlPath: null,
            message: "One Time",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message: "Recurring",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
        ],
      },
      2: {
        questions: [
          {
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "I found these topics.",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: null,
          },
        ],
        responses: [
          {
            prevResponse: 1,
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to Address of record (account owner and address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 1,
            messageId: 1,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to third party (pay to other than account owner OR address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 1,
            messageId: 2,
            questionPath: 1,
            urlPath: null,
            message: "Wire (first or third party)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 1,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              "Journal (between WBI accounts OR WBI and Pershing LLC accounts",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 1,
            messageId: 4,
            questionPath: 1,
            urlPath: null,
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 3,
            messageId: 5,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to Address of record (account owner and address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 3,
            messageId: 6,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to third party (pay to other than account owner OR address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 3,
            messageId: 7,
            questionPath: 1,
            urlPath: null,
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 2,
          },

          {
            prevResponse: 3,
            messageId: 8,
            questionPath: 1,
            urlPath: null,
            message: "Wire (first or third party)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 3,
            messageId: 9,
            questionPath: 1,
            urlPath: null,
            message:
              "Journal (between WBI accounts OR WBI and Pershing LLC accounts",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 0,
            messageId: 10,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to Address of record (account owner and address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 0,
            messageId: 11,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to third party (pay to other than account owner OR address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 0,
            messageId: 12,
            questionPath: 1,
            urlPath: null,
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 0,
            messageId: 13,
            questionPath: 1,
            urlPath: null,
            message: "Wire (first or third party)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },

          {
            prevResponse: 0,
            messageId: 14,
            questionPath: 1,
            urlPath: null,
            message:
              "Journal (between WBI accounts OR WBI and Pershing LLC accounts",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 0,
            messageId: 15,
            questionPath: 1,
            urlPath: null,
            message: "Transfer request (raise cash for transfer OUT)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 16,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to Address of record (account owner and address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 17,
            questionPath: 1,
            urlPath: null,
            message:
              "Check to third party (pay to other than account owner OR address on file)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 18,
            questionPath: 1,
            urlPath: null,
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 19,
            questionPath: 1,
            urlPath: null,
            message: "Wire (first or third party)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 20,
            questionPath: 1,
            urlPath: null,
            message:
              "Journal (between WBI accounts OR WBI and Pershing LLC accounts",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
          {
            prevResponse: 2,
            messageId: 21,
            questionPath: 1,
            urlPath: null,
            message: "Transfer request (raise cash for transfer OUT)",
            selected: false,
            userId: 0,
            treeStep: 2,
          },
        ],
      },
      3: {
        questions: [
          {
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message: "I found this answer.",
            selected: false,
            userId: 1,
            treeStep: 3,
            prevResponse: null,
          },
        ],
        responses: [
          {
            prevResponse: 0,
            messageId: 0,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 1,
          },
          {
            prevResponse: 1,
            messageId: 1,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 2,
          },
          {
            prevResponse: 2,
            messageId: 2,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 3,
          },
          {
            prevResponse: 3,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 4,
          },
          {
            prevResponse: 4,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form and ACH Authorization Form to set up periodic instructions. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 5,
          },
          {
            prevResponse: 5,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Check Request Form. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 6,
          },
          {
            prevResponse: 6,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Check Request Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 7,
          },
          {
            prevResponse: 7,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the ACH Authorization Form to set up periodic instructions. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 8,
          },
          {
            prevResponse: 8,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Fed Fund Wire Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 9,
          },
          {
            prevResponse: 9,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Journal Request Form. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 10,
          },
          {
            prevResponse: 10,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Then send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 11,
          },
          {
            prevResponse: 11,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 12,
          },
          {
            prevResponse: 12,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form and ACH Authorization Form to set up standing instructions. Advisor should email completed form with instructions on distribution amount to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 13,
          },
          {
            prevResponse: 13,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 14,
          },
          {
            prevResponse: 14,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>For like registrations, advisor should send an email to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a>. For differing registrations, work with your client to complete and sign the IRA Distribution Form. Advisor should send the completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 15,
          },
          {
            prevResponse: 15,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Transfers should be submitted by receiving firm to custodian directly. Request to liquidate or halt trade pending termination should be sent to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a>. Transfers should be submitted by receiving firm to custodian directly, NOT WBI.</span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 16,
          },
          {
            prevResponse: 16,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Advisor may send an email to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 17,
          },
          {
            prevResponse: 17,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Check Request Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 18,
          },
          {
            prevResponse: 18,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the ACH Authorization Form to set up standing instructions. Advisor should send the completed form with instructions on distribution amount to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 19,
          },
          {
            prevResponse: 19,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Fed Fund Wire Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 20,
          },
          {
            prevResponse: 20,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>For like registrations, advisor should send an email to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a>. For differing registrations, work with your client to complete and sign the Journal Request Form. Advisor should send completed form to  <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 21
          },
          {
            prevResponse: 21,
            messageId: 3,
            questionPath: 1,
            urlPath: null,
            message:
              <span>Transfers should be submitted by receiving firm to custodian directly. Request to liquidate or halt trade pending termination should be sent to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a>. Transfers should be submitted by receiving firm to custodian directly, NOT WBI.</span>,
            selected: false,
            userId: 1,
            treeStep: 3,
            globalId: 22
          },
        ],
      },
    },
  },
  2: {
    name: "Standing instructions",
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 3,
            message: "Ok, is this for?...",
            selected: false,
            userId: 1,
            treeStep: 0,
            urlPath: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message: "Retirement Account",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 2,
            urlPath: null,
            message: "Non-Retirement Account",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            questionPath: 2,
            message: "Ok, I found these how to guides.",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message: "Set up ACH instructions",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 1,
          },
          {
            messageId: 1,
            questionPath: 2,
            urlPath: null,
            message: "Set up Wire instructions",
            selected: false,
            prevResponse: 1,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 2,
            questionPath: 2,
            urlPath: null,
            message: "Set up Standing ACH instructions",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 3,
            questionPath: 2,
            urlPath: null,
            message: "Set up standing delivery instructions (other than ACH)",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 4,
            questionPath: 2,
            urlPath: null,
            message: "Set up standing tax withholding instructions",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
        ],
      },
      2: {
        questions: [
          {
            questionPath: 2,
            message: "Ok, I found this answer.",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the ACH Authorization Form to set up standing instructions. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: 0,
            globalId: 23
          },
          {
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the Fed Fund Wire Form. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            prevResponse: 1,
            userId: 1,
            treeStep: 2,
            globalId: 24
          },
          {
            prevResponse: 2,
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the ACH Authorization Form to set up standing instructions. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 25
          },
          {
            prevResponse: 3,
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form. Advisor should complete the Advisor Attestation Form (only for wires or 3rd party checks) and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 26
          },
          {
            prevResponse: 4,
            messageId: 0,
            questionPath: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the IRA Distribution Form with only Steps 1,2,4 & 6 completed. Advisor should complete the Advisor Attestation Form and send both completed forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 27
          },
        ],
      },
    },
  },
  3: {
    name: "Additions to account",
    questionPath: 3,
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 3,
            message: "Ok, is this for?...",
            selected: false,
            userId: 1,
            treeStep: 0,
            urlPath: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 3,
            urlPath: null,
            message: "One Time",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 3,
            urlPath: null,
            message: "Recurring",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            questionPath: 3,
            message: "Ok, I found these how to guides.",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            prevResponse: 0,
            messageId: 0,
            questionPath: 3,
            message: "Check",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 1,
            questionPath: 3,
            urlPath: "/Portal/faq",
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 0,
            messageId: 2,
            questionPath: 3,
            urlPath: "/Portal/faq",
            message: "Transfer request",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
          {
            prevResponse: 1,
            questionPath: 3,
            messageId: 3,
            urlPath: "/Portal/faq",
            message: "ACH",
            selected: false,
            userId: 0,
            treeStep: 1,
          },
        ],
      },
      2: {
        questions: [
          {
            questionPath: 3,
            message: "I found this answer.",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            prevResponse: 0,
            messageId: 0,
            questionPath: 3,
            message:
              <span>All checks should be made payable to Pershing LLC FBO client and mailed to: WBI Investments One River Centre | 331 Newman Springs Road, Suite 143 | Red Bank, NJ 07701</span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 28
          },
          {
            prevResponse: 1,
            messageId: 1,
            questionPath: 3,
            message:
              <span>If there are standing instructions on file for both incoming and outgoing transactions, Advisor may email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a>. If there are no existing instructions or client had selected outgoing only, work with your client to complete and sign the ACH Authorization Form to set up standing instructions. Advisor should email completed form with instructions on distribution amount to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 29
          },
          {
            prevResponse: 2,
            messageId: 2,
            questionPath: 3,
            message:
              <span>Work with your client to complete and sign the ACAT Transfer Form. Advisor should send the completed form and latest statement to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 30
          },
          {
            prevResponse: 3,
            questionPath: 3,
            messageId: 3,
            message:
              <span>Work with your client to complete and sign the ACH Authorization Form to set up standing instructions. Advisor should email completed form with instructions on distribution amount to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 31
          },
        ],
      },
    },
  },

  4: {
    name: "Trading requests",
    questionPath: 4,
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 4,
            message: "Ok, is this for?...",
            selected: false,
            userId: 1,
            treeStep: 0,
            urlPath: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message: "Temporary reserve",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 4,
            urlPath: null,
            message: "Permanent reserve",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 2,
            questionPath: 4,
            urlPath: null,
            message: "Halt trading",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 3,
            questionPath: 4,
            urlPath: null,
            message: "Termination",
            selected: false,
            userId: 0,
            treeStep: 0,
          },

          {
            messageId: 4,
            questionPath: 4,
            urlPath: null,
            message: "Liquidate",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 5,
            questionPath: 4,
            urlPath: null,
            message: "Resume Trading",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            questionPath: 4,
            message: "Ok, I found these how to guides.",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message: "Raise funds temporarily to hold in cash",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 0,
          },
          {
            messageId: 1,
            questionPath: 4,
            urlPath: null,
            message: "Raise funds to keep on reserve permanently",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 1,
          },
          {
            messageId: 2,
            questionPath: 4,
            urlPath: null,
            message: "Temporarily halt trading on account",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 3,
            questionPath: 4,
            urlPath: null,
            message: "Halt trade pending termination",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 3,
          },
          {
            messageId: 4,
            questionPath: 4,
            urlPath: null,
            message:
              "Liquidate and hold in cash – meant to be on a temporary basis",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 4,
          },
          {
            messageId: 5,
            questionPath: 4,
            urlPath: null,
            message: "Liquidate pending termination",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 4,
          },
          {
            messageId: 6,
            questionPath: 4,
            urlPath: null,
            message: "Resume trading and Reinvest account",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 5,
          },
        ],
      },
      2: {
        questions: [
          {
            questionPath: 4,
            message: "Ok, I found this answer.",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            prevResponse: 0,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 32
          },
          {
            prevResponse: 1,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 33
          },
          {
            prevResponse: 2,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 34
          },
          {
            prevResponse: 3,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 35
          },
          {
            prevResponse: 4,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 36
          },
          {
            prevResponse: 5,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 37
          },
          {
            prevResponse: 6,
            messageId: 0,
            questionPath: 4,
            urlPath: null,
            message:
              <span>Advisor should email instructions to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 38
          },
        ],
      },
    },
  },
  5: {
    name: "Advisor settings changes",
    questionPath: 5,
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 5,
            message: "How can I help?",
            selected: false,
            userId: 1,
            treeStep: 0,
            urlPath: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 5,
            urlPath: null,
            message: "How do I change my personal information?",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 5,
            urlPath: null,
            message:
              'My portfolios are defaulting to "All" manager types. How can I change that?',
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 2,
            questionPath: 5,
            urlPath: null,
            message:
              "My fee isn't 1.00%. How can I update that automatically for all of my clients?",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 3,
            questionPath: 5,
            urlPath: null,
            message:
              "I can’t move past the start page in the client profile creation.",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 4,
            questionPath: 5,
            urlPath: null,
            message:
              "How do I calculate monthly expenses pre and post-retirement?",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 5,
            questionPath: 5,
            urlPath: null,
            message:
              "Do I want to solve for risk or return?",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            questionPath: 5,
            message: "I found this answer.",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 5,
            prevResponse: 0,
            urlPath: null,
            message:
              <span>Click the gear icon in the navigation pane and select “My Profile.” Here you will be able to update things like your contact information and where to send duplicate correspondence. <Link to='/Portal/user/profile'>Take me there</Link></span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 39
          },
          {
            messageId: 1,
            questionPath: 5,
            prevResponse: 1,
            urlPath: null,
            message:
              <span>Click the gear icon in the navigation pane and select “Advisor Settings.” Here you will be able to update things like your default Manager Type, Base Advisor Fee, and the Risk Selection. <Link to='/Portal/user/advisorSettings'>Take me there</Link></span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 40
          },
          {
            messageId: 2,
            questionPath: 5,
            prevResponse: 2,
            urlPath: null,
            message:
              <span>Click the gear icon in the navigation pane and select “Advisor Settings.” Here you will be able to update things like your Base Advisor Fee, default Manager Type, and the Risk Selection. <Link to='/Portal/user/advisorSettings'>Take me there</Link></span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 41
          },
          {
            messageId: 3,
            questionPath: 5,
            prevResponse: 3,
            urlPath: null,
            message:
              <span>Did you watch the video? If this is you first time using Cy, please watch the video one full time and click the orange “Start” Button in the bottom right of the window upon it’s completion.</span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 52
          },
          {
            messageId: 4,
            questionPath: 5,
            prevResponse: 4,
            urlPath: null,
            message:
              <span>Check out <Link to='/Portal/education'>this</Link> helpful resource in our Education section.</span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 53
          },
          {
            messageId: 5,
            questionPath: 5,
            prevResponse: 5,
            urlPath: null,
            message:
              <span>Solving for risk allows Cy to maximize portfolio return given an investor’s loss tolerance or risk constraint, but switch to return if you want Cy to minimize portfolio risk given an investor’s return target.</span>,
            selected: false,
            userId: 1,
            treeStep: 1,
            globalId: 54
          },
        ],
      },
    },
  },
  6: {
    name: "account changes",
    questionPath: 6,
    steps: {
      0: {
        questions: [
          {
            messageId: 0,
            questionPath: 6,
            message: "What account changes can I help with?",
            selected: false,
            userId: 1,
            treeStep: 0,
            urlPath: null,
            prevResponse: null,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 6,
            urlPath: null,
            message: "Retirement",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 1,
            questionPath: 6,
            urlPath: null,
            message: "Non-retirement",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
          {
            messageId: 2,
            questionPath: 6,
            urlPath: null,
            message: "General Account Changes",
            selected: false,
            userId: 0,
            treeStep: 0,
          },
        ],
      },
      1: {
        questions: [
          {
            questionPath: 6,
            message: "Ok, I found these options.",
            selected: false,
            userId: 1,
            treeStep: 1,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 6,
            urlPath: null,
            message: "Beneficiary change/add",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 0,
          },
          {
            messageId: 1,
            questionPath: 6,
            urlPath: null,
            message: "Beneficiary change/add",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 1,
          },
          {
            messageId: 2,
            questionPath: 6,
            urlPath: null,
            message: "Address change",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 3,
            questionPath: 6,
            urlPath: null,
            message: "Fee change",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 4,
            questionPath: 6,
            urlPath: null,
            message: "Strategy change",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 5,
            questionPath: 6,
            urlPath: null,
            message: "Name change (due to marriage, divorce)",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 6,
            questionPath: 6,
            urlPath: null,
            message: "Name/registration change (adding account holder)",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 7,
            questionPath: 6,
            urlPath: null,
            message: "Name/registration change (removing account holder)",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 8,
            questionPath: 6,
            urlPath: null,
            message: "Rep change",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
          {
            messageId: 9,
            questionPath: 6,
            urlPath: null,
            message: "Solicitor change",
            selected: false,
            userId: 0,
            treeStep: 1,
            prevResponse: 2,
          },
        ],
      },
      2: {
        questions: [
          {
            questionPath: 6,
            message: "I found these answers",
            selected: false,
            userId: 1,
            treeStep: 2,
            prevResponse: null,
            messageId: 0,
          },
        ],
        responses: [
          {
            messageId: 0,
            questionPath: 6,
            prevResponse: 0,
            urlPath: null,
            message:
              <span>Work with your client to complete the Designation of Beneficiary Form. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 42
          },
          {
            messageId: 1,
            questionPath: 6,
            prevResponse: 1,
            urlPath: null,
            message:
              <span>Work with your client to complete the Individual or Joint Transfer on Death Form. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 43
          },
          {
            messageId: 2,
            questionPath: 6,
            prevResponse: 2,
            urlPath: null,
            message:
              <span>Work with your client to complete the Change of Address Authorization Form. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 44
          },
          {
            messageId: 3,
            questionPath: 6,
            prevResponse: 3,
            urlPath: null,
            message:
              <span>Advisor completes the Cy Advisor Fee Change Form (increase or decrease). For fee increases, form must be signed by client. Advisor should email completed form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 45
          },
          {
            messageId: 4,
            questionPath: 6,
            prevResponse: 4,
            urlPath: null,
            message:
              <span>Locate the onboarded client account in Cy. Select “View” and at the bottom click “Change Strategy.” This will allow you to change the strategy selections for the client. Work with your client to complete and sign the Strategy Change Form. Advisor should submit the Strategy Change Form and Cy Summary via DocuSign or a wet signed copy to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 46
          },
          {
            messageId: 5,
            questionPath: 6,
            prevResponse: 5,
            urlPath: null,
            message:
              <span>Work with your client sign a letter of authorization indicating the change. Advisor should email completed form along with documentation (marriage certificate /divorce decree to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 47
          },
          {
            messageId: 6,
            questionPath: 6,
            prevResponse: 6,
            urlPath: null,
            message:
              <span>Work with your clients to complete and sign: Letter of authorization requesting to add the new client (and change name if applicable) and new Cy agreements and client being added must sign the additional account holder supplement form. Advisor should send completed form along with documentation (marriage certificate /divorce decree to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 48
          },
          {
            messageId: 7,
            questionPath: 6,
            prevResponse: 7,
            urlPath: null,
            message:
              <span>Work with your client to sign a letter of authorization indicating the change. An account holder may only be removed if they are the second account holder on the account. Advisor should email completed form along with documentation (marriage certificate /divorce decree to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 49
          },
          {
            messageId: 8,
            questionPath: 6,
            prevResponse: 8,
            urlPath: null,
            message:
              <span>Advisor may submit their BD Rep Change Form to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 50
          },
          {
            messageId: 9,
            questionPath: 6,
            prevResponse: 9,
            urlPath: null,
            message:
              <span>Work with your client to complete and sign the BD Rep Change Form in addition to a new Investment Management Agreement. The new advisor should submit these forms to <a href='mailto:servicerequests@investwithcy.com' target={'_blank'}>servicerequests@investwithcy.com</a></span>,
            selected: false,
            userId: 1,
            treeStep: 2,
            globalId: 51
          },
        ],
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/HelpWidget/components/QuestionTree/index.jsx